const state = {
  loading: false,
  success: false,
  error: false,
  subscriptionList: [],
  subscriptions: {},
};

export default state;
